/* TIRE OX — Email capture popup (2-step) with optional Year/Make/Model.
   Self-contained asset: injects its own HTML + CSS, posts to Shopify's native
   /contact customer form (email marketing). Vehicle stored as customer tags.
   Offer: 10% off first order (code OX10).
   Trigger: exit-intent (desktop) + 50% scroll OR 8s (mobile). Shows once per visitor. */
(function () {
  var KEY = 'oxPopupSeen';
  if (localStorage.getItem(KEY) === 'v1') return;

  var css = [
    '#ox-popup-overlay{position:fixed;inset:0;background:rgba(35,39,31,.55);display:none;align-items:center;justify-content:center;z-index:99999;padding:16px}',
    '#ox-popup-overlay.ox-open{display:flex;animation:oxFade .25s ease}',
    '@keyframes oxFade{from{opacity:0}to{opacity:1}}',
    '.ox-card{background:#F4EFE3;color:#23271F;max-width:440px;width:100%;border-radius:14px;box-shadow:0 18px 50px rgba(0,0,0,.35);position:relative;padding:34px 30px 30px;font-family:inherit;line-height:1.45;animation:oxRise .3s ease}',
    '@keyframes oxRise{from{transform:translateY(14px);opacity:0}to{transform:translateY(0);opacity:1}}',
    '.ox-close{position:absolute;top:12px;right:14px;background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#23271F;opacity:.55}',
    '.ox-close:hover{opacity:1}',
    '.ox-eyebrow{font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#C25A2B;font-weight:700;margin:0 0 8px}',
    '.ox-card h2{font-size:25px;margin:0 0 8px;line-height:1.15;font-weight:800}',
    '.ox-card p.ox-sub{margin:0 0 18px;font-size:15px;opacity:.85}',
    '.ox-field{display:block;width:100%;padding:12px 14px;margin:0 0 12px;border-radius:9px;border:1px solid #c9c0ac;background:#fff;font-size:15px;color:#23271F;box-sizing:border-box}',
    '.ox-field:focus{outline:none;border-color:#C25A2B;box-shadow:0 0 0 3px rgba(194,90,43,.18)}',
    '.ox-row{display:flex;gap:10px}',
    '.ox-row .ox-field{margin-bottom:12px}',
    '.ox-btn{display:block;width:100%;padding:14px;border:none;border-radius:9px;background:#C25A2B;color:#fff;font-size:16px;font-weight:700;cursor:pointer;letter-spacing:.02em;transition:background .15s}',
    '.ox-btn:hover{background:#a84a22}',
    '.ox-skip{display:block;width:100%;background:none;border:none;margin-top:12px;color:#23271F;opacity:.6;font-size:14px;cursor:pointer;text-decoration:underline}',
    '.ox-skip:hover{opacity:1}',
    '.ox-err{color:#a02c1a;font-size:13px;margin:-6px 0 12px;display:none}',
    '.ox-step{display:none}',
    '.ox-step.ox-active{display:block}',
    '.ox-code-box{background:#23271F;color:#F4EFE3;border-radius:10px;padding:16px;text-align:center;margin:6px 0 4px}',
    '.ox-code{font-size:26px;font-weight:800;letter-spacing:.18em;color:#fff}',
    '.ox-fine{font-size:12px;opacity:.6;margin-top:14px}',
    '@media(max-width:480px){.ox-card{padding:30px 20px 24px}.ox-card h2{font-size:22px}.ox-row{flex-direction:column;gap:0}}'
  ].join('');

  var html =
    '<div id="ox-popup-overlay" role="dialog" aria-modal="true" aria-labelledby="ox-popup-title">' +
    '<div class="ox-card">' +
    '<button type="button" class="ox-close" aria-label="Close" data-ox-close>&times;</button>' +
    '<form id="ox-customer-form" method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
    '<input type="hidden" name="form_type" value="customer">' +
    '<input type="hidden" name="utf8" value="✓">' +
    '<input type="hidden" name="contact[tags]" id="ox-tags" value="popup-signup">' +
    // step 1
    '<div class="ox-step ox-active" data-step="1">' +
    '<p class="ox-eyebrow">Welcome to the herd</p>' +
    '<h2 id="ox-popup-title">Get 10% off your first set</h2>' +
    '<p class="ox-sub">Real tires, plain talk, no upsell games. Drop your email and we\'ll send your code &mdash; plus tips to make your tires last longer.</p>' +
    '<input class="ox-field" type="text" name="contact[first_name]" id="ox-fname" placeholder="First name" autocomplete="given-name">' +
    '<input class="ox-field" type="email" name="contact[email]" id="ox-email" placeholder="you@email.com" autocomplete="email" required>' +
    '<p class="ox-err" id="ox-email-err">Please enter a valid email.</p>' +
    '<button type="button" class="ox-btn" id="ox-continue">Continue &rarr;</button>' +
    '<p class="ox-fine">One email, your code, and the occasional tire-care tip. Unsubscribe anytime.</p>' +
    '</div>' +
    // step 2
    '<div class="ox-step" data-step="2">' +
    '<p class="ox-eyebrow">Optional &mdash; helps us help you</p>' +
    '<h2>What do you drive?</h2>' +
    '<p class="ox-sub">Tell us your vehicle and we\'ll only show you tires that actually fit. You can skip this.</p>' +
    '<div class="ox-row">' +
    '<input class="ox-field" type="text" inputmode="numeric" maxlength="4" name="ox_year" id="ox-year" placeholder="Year">' +
    '<input class="ox-field" type="text" name="ox_make" id="ox-make" placeholder="Make (e.g. Honda)">' +
    '</div>' +
    '<input class="ox-field" type="text" name="ox_model" id="ox-model" placeholder="Model (e.g. Civic)">' +
    '<button type="submit" class="ox-btn" id="ox-submit-vehicle">Get my 10% code</button>' +
    '<button type="button" class="ox-skip" id="ox-skip">Skip &mdash; just send the code</button>' +
    '</div>' +
    // step 3
    '<div class="ox-step" data-step="3">' +
    '<p class="ox-eyebrow">You\'re in</p>' +
    '<h2>Here\'s your 10% off</h2>' +
    '<p class="ox-sub">Use this code at checkout on your first order:</p>' +
    '<div class="ox-code-box"><span class="ox-code">OX10</span></div>' +
    '<button type="button" class="ox-btn" id="ox-shop" style="margin-top:16px">Start shopping</button>' +
    '<p class="ox-fine">We also emailed it to you so it\'s easy to find later.</p>' +
    '</div>' +
    '</form></div></div>';

  function init() {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    document.body.appendChild(wrap);

    var overlay = document.getElementById('ox-popup-overlay');
    var form = document.getElementById('ox-customer-form');
    var steps = overlay.querySelectorAll('.ox-step');
    var tagsEl = document.getElementById('ox-tags');
    var emailEl = document.getElementById('ox-email');
    var emailErr = document.getElementById('ox-email-err');
    var opened = false, submitted = false;

    function show(n) { steps.forEach(function (s) { s.classList.toggle('ox-active', s.dataset.step == n); }); }
    function open() {
      if (opened) return; opened = true;
      overlay.classList.add('ox-open');
      localStorage.setItem(KEY, 'v1');
      document.removeEventListener('mouseout', exitIntent);
      window.removeEventListener('scroll', onScroll);
    }
    function close() { overlay.classList.remove('ox-open'); }

    function exitIntent(e) { if (!e.relatedTarget && e.clientY < 10) open(); }
    function onScroll() {
      var h = document.documentElement;
      var pct = (h.scrollTop || document.body.scrollTop) / ((h.scrollHeight - h.clientHeight) || 1);
      if (pct > 0.5) open();
    }
    document.addEventListener('mouseout', exitIntent);
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(open, 8000);

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelectorAll('[data-ox-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.getElementById('ox-continue').addEventListener('click', function () {
      var v = (emailEl.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { emailErr.style.display = 'block'; emailEl.focus(); return; }
      emailErr.style.display = 'none';
      show(2);
    });

    function buildTags() {
      var tags = ['popup-signup'];
      var y = (document.getElementById('ox-year').value || '').trim();
      var mk = (document.getElementById('ox-make').value || '').trim();
      var md = (document.getElementById('ox-model').value || '').trim();
      if (y || mk || md) {
        tags.push('vehicle: ' + [y, mk, md].filter(Boolean).join(' '));
        if (y) tags.push('year-' + y);
        if (mk) tags.push('make-' + mk.toLowerCase());
      }
      tagsEl.value = tags.join(', ');
    }
    function finish() { if (submitted) return; submitted = true; show(3); }
    function sendForm() {
      buildTags();
      try {
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(finish).catch(finish);
      } catch (err) { finish(); }
    }
    document.getElementById('ox-skip').addEventListener('click', sendForm);
    form.addEventListener('submit', function (e) { e.preventDefault(); sendForm(); });

    document.getElementById('ox-shop').addEventListener('click', function () {
      close();
      if (!/\/collections\//.test(location.pathname)) location.href = '/collections/all';
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();